<template>
  <el-dialog :title="action === 'edit' ? $t('text.editConfig') : $t('text.addConfig')"
             :visible="show"
             @open="init"
             @close="close"
             :close-on-click-modal="false"
             width="600px">
    <el-form :model="form" :rules="rules" ref="form" label-width="110px">
      <el-form-item :label="$t('text.parserCode')"
                    prop="code"
                    :disabled="action === 'edit'">
        <el-select v-model="form.code"
                   filterable
                   :placeholder="$t('message.selectParserCode')"
                   :disabled="action === 'edit'">
          <el-option v-for="type in typeList"
                     :key="type.name"
                     :label="type.name"
                     :value="type.value"/>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.mailSubject')"
                    prop="mailSubject">
        <el-input v-model="form.mailSubject"
                  auto-complete="off"
                  :placeholder="$t('message.inputMailSubject')"/>
      </el-form-item>
      <el-form-item :label="$t('text.collectionText')"
                    prop="collectionText">
        <el-input v-model="form.collectionText"
                  auto-complete="off"
                  :placeholder="$t('message.inputCollectionText')"/>
      </el-form-item>
      <el-form-item :label="$t('text.parserConfig')"
                    prop="parserConfig">
        <el-input v-model="form.parserConfig"
                  type="textarea"
                  :autosize="{ minRows: 5 }"
                  :placeholder="$t('message.selectParserCode')"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "MailParserInfoEdit",
  props: {
    show: Boolean,
    value: Object,
    action: String
  },
  data() {
    return {
      form: this.newFormData(),
      rules: {
        code: [
          {required: true, message: this.$t('message.selectParserCode'), trigger: ["blur", "change"]},
        ],
        mailSubject: [
          {required: true, message: this.$t('message.inputMailSubject'), trigger: ["blur", "change"]},
          {max: 100, message: this.$t('message.lengthMax100Error'), trigger: ["blur", "change"]}
        ],
        collectionText: [
          {max: 100, message: this.$t('message.lengthMax100Error'), trigger: ["blur", "change"]}
        ],
        parserConfig: [
          {required: true, message: this.$t('message.inputParserConfig'), trigger: ["blur", "change"]},
          {max: 4000, message: this.$t('message.lengthMax4000Error'), trigger: ["blur", "change"]}
        ]
      },
      typeList: [],
    };
  },
  methods: {
    init() {
      if (this.action === "edit") {
        this.form = Object.assign({}, this.value);
      }
    },
    close() {
      this.form = this.newFormData();
      this.$refs["form"].resetFields();
      this.$emit("update:show", false);
    },
    getTypeList() {
      this.$axios
          .get("/mailParserInfo/selectStatementProviderOptions", {params: {}})
          .then((res) => {
            if (res.code === 200) {
              this.typeList = res.data;
            }
          });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const url = this.action === "add" ?
              "/mailParserInfo/mailParserInfoAdd" :
              "/mailParserInfo/mailParserInfoUpdate";

          this.$axios
              .post(url, this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify.success({
                    title: this.$t("text.prompt"),
                    message: res.msg
                  });

                  this.$bus.$emit("refresh");
                  this.close();
                  return true;
                } else {
                  this.$notify.error({
                    title: this.$t("text.prompt"),
                    message: res.msg
                  });
                  return false;
                }
              });
        } else {
          return false;
        }
      });
    },
    newFormData() {
      return {
        code: null,
        mailSubject: null,
        collectionText: null,
        parserConfig: null
      };
    }
  },
  mounted() {
    this.getTypeList();
  }
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>